module.exports = __webpack_public_path__ + "img/Fond_Carte_Wilwar_XS_Neutre.b115aa08.png";